import { FunctionComponent } from 'react'

import { RootStackScreenComponentProps } from 'src/navigation'

export type HiringScreenComponent = FunctionComponent<HiringScreenProps>

export type HiringScreenProps = RootStackScreenComponentProps<'Hiring'>

export type ResponsiveHiringScreenComponent = FunctionComponent<ReturnType<UseHiringScreen>>

export type UseHiringScreen = ({ navigation }: Pick<HiringScreenProps, 'navigation' | 'route'>) => {
  isMobile: boolean
  url?: string
}

// PowerApps URLs constants
export const POWERAPPS_BASE_URL =
  'https://apps.powerapps.com/play/e/fa202e3d-3516-e92f-a526-7811aa5d3b46'

export const TENANT_ID = '35595a02-4d6d-44ac-99e1-f9ab4cd872db'

export const HIRING_URLS = {
  WALLETS_MANAGEMENT: `${POWERAPPS_BASE_URL}/a/09e6dd3a-dcd6-4fcb-bc81-35bf0b5fa0e9?tenantId=${TENANT_ID}&hint=88dcff84-16cd-415f-83f7-44609acd24a0&sourcetime=1755021052727`,
  GOALS: `${POWERAPPS_BASE_URL}/a/21e1cc2f-3b2d-4f4e-a9ac-f741e07c67b3?tenantId=${TENANT_ID}&hint=c4875f99-16f7-482a-ae65-232ac9777095&sourcetime=1755021125847`,
  DELEGATION: `${POWERAPPS_BASE_URL}/a/a68b9a25-9c68-42bb-83e4-93b08620ab91?tenantId=${TENANT_ID}&hint=fa8c3a50-25e4-4a0a-9435-a50159dd5d4b&sourcetime=1755021094604`,
  MIGRATION: `${POWERAPPS_BASE_URL}/a/2d98fe74-22c4-4046-87a6-6f1dff41b23a?tenantId=${TENANT_ID}&hint=a5e60d37-78ab-46fb-8ebf-773ad640d216&sourcetime=1762798560352`,
  SIM_WALLETS_MANAGEMENT: `${POWERAPPS_BASE_URL}/a/09e6dd3a-dcd6-4fcb-bc81-35bf0b5fa0e9?tenantId=${TENANT_ID}&hint=88dcff84-16cd-415f-83f7-44609acd24a0&sourcetime=1755021052727`,
  SIM_GOALS: `${POWERAPPS_BASE_URL}/a/21e1cc2f-3b2d-4f4e-a9ac-f741e07c67b3?tenantId=${TENANT_ID}&hint=c4875f99-16f7-482a-ae65-232ac9777095&sourcetime=1755021125847`,
  SIM_DELEGATION: `${POWERAPPS_BASE_URL}/a/a68b9a25-9c68-42bb-83e4-93b08620ab91?tenantId=${TENANT_ID}&hint=fa8c3a50-25e4-4a0a-9435-a50159dd5d4b&sourcetime=1755021094604`,
  SIM_MIGRATION: `${POWERAPPS_BASE_URL}/a/2d98fe74-22c4-4046-87a6-6f1dff41b23a?tenantId=${TENANT_ID}&hint=a5e60d37-78ab-46fb-8ebf-773ad640d216&sourcetime=1762798560352`
} as const
